/**
 * @name LoadGames
 * @returns {Game[]} logs
 */
export function LoadGames() {
  const savedGames = localStorage.getItem("savedGames");
  /** @type {Game[]} */
  let games = [];
  if (savedGames) {
    games = JSON.parse(savedGames);
  }
  return games;
}
